import React from 'react';
import styles from './PoliticaDePrivacidade.module.scss';
import { Helmet } from 'react-helmet';

const PoliticaPrivacidade = () => {
  return (
    <>
      <Helmet>
        <title>Política de Privacidade - Alcance Tecnologia</title>
        <meta name="description" content="Conheça nossa política de privacidade e como protegemos seus dados pessoais." />
      </Helmet>
      
      <div className={styles.container}>
        <div className={styles.header}>
          <h1>Política de Privacidade</h1>
          <p>Última atualização: 15 de Novembro de 2023</p>
        </div>

        <div className={styles.content}>
          <section className={styles.section}>
            <h2>1. Introdução</h2>
            <p>
              Na Alcance Tecnologia, levamos a privacidade e a proteção de dados pessoais a sério. 
              Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos 
              suas informações quando você utiliza nossos serviços.
            </p>
            <p>
              Ao acessar nosso site e utilizar nossos serviços, você concorda com os termos desta 
              Política de Privacidade. Recomendamos que você leia atentamente este documento para 
              entender nossas práticas em relação aos seus dados pessoais.
            </p>
          </section>

          <section className={styles.section}>
            <h2>2. Informações que Coletamos</h2>
            <p>Coletamos diferentes tipos de informações para fornecer e melhorar nossos serviços:</p>
            
            <h3>2.1. Informações fornecidas voluntariamente</h3>
            <ul>
              <li>Nome completo</li>
              <li>Endereço de e-mail</li>
              <li>Número de telefone</li>
              <li>Empresa/organização</li>
              <li>Conteúdo de mensagens enviadas através de formulários de contato</li>
            </ul>

            <h3>2.2. Informações coletadas automaticamente</h3>
            <ul>
              <li>Endereço de IP e tipo de dispositivo</li>
              <li>Dados de navegação e interação com o site</li>
              <li>Informações de cookies e tecnologias similares</li>
              <li>Dados de uso de nossos serviços</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>3. Como Utilizamos Suas Informações</h2>
            <p>Utilizamos suas informações pessoais para as seguintes finalidades:</p>
            <ul>
              <li>Fornecer, operar e manter nossos serviços</li>
              <li>Melhorar, personalizar e expandir nossos serviços</li>
              <li>Compreender e analisar como você utiliza nossos serviços</li>
              <li>Desenvolver novos produtos, serviços, funcionalidades e recursos</li>
              <li>Comunicar-nos com você, diretamente ou através de nossos parceiros</li>
              <li>Enviar e-mails com atualizações e outras informações</li>
              <li>Encontrar e prevenir fraudes</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>4. Compartilhamento de Informações</h2>
            <p>
              Não vendemos, comercializamos ou transferemos suas informações pessoais para terceiros, 
              exceto nas seguintes situações:
            </p>
            <ul>
              <li>Prestadores de serviços que nos auxiliam em nossas operações</li>
              <li>Quando necessário para cumprir com a lei ou processos legais</li>
              <li>Para proteger nossos direitos, propriedade ou segurança</li>
              <li>Em conexão com uma fusão, aquisição ou venda de ativos</li>
            </ul>
            <p>
              Exigimos que todos os terceiros respeitem a segurança de seus dados pessoais e os tratem 
              de acordo com a lei.
            </p>
          </section>

          <section className={styles.section}>
            <h2>5. Cookies e Tecnologias Similares</h2>
            <p>
              Utilizamos cookies e tecnologias similares para rastrear a atividade em nosso site e 
              armazenar determinadas informações. Os cookies podem ser:
            </p>
            <ul>
              <li>
                <strong>Cookies essenciais:</strong> Necessários para o funcionamento do site
              </li>
              <li>
                <strong>Cookies de desempenho:</strong> Coletam informações sobre como os visitantes usam o site
              </li>
              <li>
                <strong>Cookies de funcionalidade:</strong> Permitem que o site forneça funcionalidades personalizadas
              </li>
              <li>
                <strong>Cookies de targeting:</strong> Usados para entregar anúncios relevantes aos usuários
              </li>
            </ul>
            <p>
              Você pode configurar seu navegador para recusar todos os cookies ou para indicar quando 
              um cookie está sendo enviado. No entanto, se você não aceitar cookies, pode não ser capaz 
              de usar algumas partes do nosso site.
            </p>
          </section>

          <section className={styles.section}>
            <h2>6. Armazenamento e Segurança de Dados</h2>
            <p>
              Suas informações são armazenadas em servidores seguros e adotamos medidas técnicas e 
              organizacionais apropriadas para proteger seus dados pessoais contra acesso não autorizado, 
              alteração, divulgação ou destruição.
            </p>
            <p>
              Mantemos suas informações pessoais apenas pelo tempo necessário para cumprir com as 
              finalidades descritas nesta Política de Privacidade, a menos que um período de retenção 
              mais longo seja exigido ou permitido por lei.
            </p>
          </section>

          <section className={styles.section}>
            <h2>7. Seus Direitos de Privacidade</h2>
            <p>Você possui os segu direitos em relação aos seus dados pessoais:</p>
            <ul>
              <li>Acesso às informações que mantemos sobre você</li>
              <li>Retificação de informações imprecisas ou incompletas</li>
              <li>Exclusão de seus dados pessoais (direito ao esquecimento)</li>
              <li>Restrição do processamento de seus dados pessoais</li>
              <li>Portabilidade de dados para outro prestador de serviços</li>
              <li>Oposição ao processamento de seus dados pessoais</li>
            </ul>
            <p>
              Para exercer qualquer um desses direitos, entre em contato conosco através dos canais 
              fornecidos na seção "Contato" desta política.
            </p>
          </section>

          <section className={styles.section}>
            <h2>8. Alterações nesta Política de Privacidade</h2>
            <p>
              Podemos atualizar nossa Política de Privacidade periodicamente. Notificaremos você sobre 
              quaisquer alterações publicando a nova Política de Privacidade nesta página e atualizando 
              a data de "Última atualização" no topo deste documento.
            </p>
            <p>
              Recomendamos que você revise esta Política de Privacidade periodicamente para quaisquer 
              alterações. As alterações a esta Política de Privacidade são efetivas quando são publicadas 
              nesta página.
            </p>
          </section>

          <section className={styles.section}>
            <h2>9. Contato</h2>
            <p>
              Se você tiver dúvidas ou preocupações sobre esta Política de Privacidade ou sobre o 
              tratamento de seus dados pessoais, entre em contato conosco:
            </p>
            <div className={styles.contactInfo}>
              <p><strong>Alcance Tecnologia</strong></p>
              <p>E-mail: privacidade@alcancetecnologia.com.br</p>
              <p>Telefone: +55 (049) 3621-1469</p>
              <p>Endereço: São Miguel do Oeste, SC Bairro São Jorge, 1727 Rua Florianópolis</p>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default PoliticaPrivacidade;